// Generated by scripts/migrate/gen-from-live.py from https://www.dietz.eu/en/produkte/tension-spring-with-extra-long-eyelet/
// Source of truth is the LIVE page, not the original markdown scrape
// (which was incomplete: this content type was missed entirely, and
// several pages were captured as summaries rather than verbatim copy).
import type { PageEntry } from "@/content/schema";

export const produkteTensionSpringWithExtraLongEyeletEN: PageEntry = {
  id: "example.produkte-zugfeder-mit-ueberlagerter-oese",
  locale: "en",
  slug: "produkte/tension-spring-with-extra-long-eyelet",
  seo: {
    title: "Tension spring with extra-long eyelet | Dietz GmbH",
    description: "Implementation with special machines and special tool fixtures – Lock and fittings industry",
  },
  type: "post",
  h1: "Tension spring with extra-long eyelet",
  intro: "Implementation with special machines and special tool fixtures – Lock and fittings industry",
  blocks: [
    { kind: "image", src: "/images/live/dtz-zugfeder-ueberlang.jpg", alt: "Tension spring with extra-long eyelet", width: 1280, height: 1024 }
  ],
};
